export const sizes = {
  '3xl': '35rem', // 560px
  '7xl': '82.125rem', // 1314px
  '9xl': '100rem', // 1600px
  '10xl': '112rem', // 1792px
};
